var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("j-editable-table", {
    ref: "sortTable",
    attrs: {
      rowNumber: "",
      dragSort: "",
      columns: _vm.columns,
      dataSource: _vm.dataSource,
      sortInsertDown: false
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }